import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FaDownload, FaSpinner } from "react-icons/fa";
import Popup from "reactjs-popup";
import * as XLSX from "xlsx";
import { DashboardLoading } from "../../../../CommonComponents/Loader";
import EmptyDataAlert from "../../../../CommonComponents/EmptyDataAlert";
import DataTable from "../../../../CommonComponents/DataTable";
import Pagination from "../../../../CommonComponents/Pagination";
import { fetchBankData } from "../../../../../Services/BankOnboarding";

const AllBanks = ({ isOpen, onClose }) => {
  const [userData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [showLoanDetails, setShowLoanDetails] = useState(false);
  const [isExportLoading, setExportLoading] = useState();
  const [error, setError] = useState(false);
  const [isExport, setIsExport] = useState(true);
  const [pagination, setPagination] = useState({
    totalDocs: 0,
    totalPages: 1,
    page: 0,
    limit: 10,
    hasNextPage: false,
    hasPrevPage: false,
  });

  const columns = React.useMemo(
    () => [
      {
        Header: 'Bank Name',
        accessor: 'name',
      },
      {
        Header: 'Bank Address',
        accessor: 'address.address',
      },
      {
        Header: 'Manager Name',
        accessor: 'poc.name',
      },
      {
        Header: 'Contact No.',
        accessor: 'phone_number',
      },
      {
        Header: 'Email',
        accessor: 'email',
      }
    ],
    []
  );

  const data = React.useMemo(() => userData);

  const fetchData = useCallback(async (page = 1, query = searchQuery) => {
    setLoading(true);
    try {
      const data = await fetchBankData(!isExport, page, query);
      console.log("Data is here: ", data);
      setUsersData(data?.docs);
      setPagination({
        totalPages: data.totalPages,
        page: data.page,
        hasNextPage: data.hasNextPage,
        hasPrevPage: data.hasPrevPage,
      });
      setLoading(false);
    } catch (error) {
      setSearchQuery("");
      setLoading(false);
    }
  });

  useEffect(() => {
    fetchData();
  }, []);

  const exportToExcel = async () => {
    setExportLoading(true);
    const data = await fetchBankData(isExport, "", "");
    setExportLoading(false);
    const ws = XLSX.utils.json_to_sheet(data?.docs);
    const columnWidths = [
      { wch: 30 },
      { wch: 20 },
      { wch: 30 },
      { wch: 15 },
      { wch: 10 },
    ];
    ws["!cols"] = columnWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "All_Banks");
    XLSX.writeFile(wb, "All_Banks.xlsx");
  };

  const handleSearch = async () => {
    setLoading(true);
    fetchData(1, searchQuery);
  };

  const nextPage = useCallback(() => {
    if (pagination.hasNextPage) fetchData(pagination.page + 1, searchQuery);
  }, [fetchData, searchQuery, pagination]);

  const previousPage = useCallback(() => {
    if (pagination.hasPrevPage) fetchData(pagination.page - 1, searchQuery);
  }, [fetchData, searchQuery, pagination]);

  return (
    <>
      <Popup
        open={isOpen}
        modal
        closeOnDocumentClick={false}
        className="custom-popup"
      >
        <div className="popup-style popup-content">
          <div className="bg-bgclr4 md:w-[950px] w-[400px]  mx-auto h-[520px] rounded-[14px]">
            <div className="flex justify-between font-avenir text-bgclr px-10 pt-5">
              <h1 className="text-[20px] font-[600] ">
                All Banks
              </h1>
              <div className="flex gap-4">
                <button
                  type="submit"
                  onClick={() => {
                    exportToExcel();
                  }}
                    disabled={loading || isExportLoading}
                  className="flex gap-2 items-center py-1 px-7  bg-bgclr rounded-md text-txtclr"
                >
                  {isExportLoading ? (
                    <FaSpinner size={18} className="animate-spin text-txtclr" />
                  ) : (
                    <FaDownload size={18} />
                  )}{" "}
                  Download Report
                </button>
                <button
                  type="submit"
                  onClick={() => {
                    onClose();
                  }}
                    disabled={loading}
                  className="font-bold py-1 px-3 rounded-md bg-red-700 text-txtclr"
                >
                  X
                </button>
              </div>
            </div>
            <div>
              {!showLoanDetails ? (
                <div>
                  <div className="searchBar-style-dashboard">
                    <input
                      type="search"
                      placeholder="Search by name, CUID, email, phone no."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="searchBar-input-dashboard"
                    />
                    <button
                      onClick={() => handleSearch()}
                      className="searchBar-btn-dashboard"
                    >
                      Search
                    </button>
                  </div>
                  {loading ? (
                    <div className="flex justify-center h-[360px] items-center">
                      <DashboardLoading />
                    </div>
                  ) : (
                    <>
                      {userData?.length === 0 ? (
                        <div className="h-screen">
                          <EmptyDataAlert
                            title={
                              error
                                ? "No Loans Found"
                                : "Search Loan by Loan number"
                            }
                          />
                        </div>
                      ) : (
                        <div className="mt-2">
                          <div>
                            <div className="pt-3 w-[900px] mx-auto overflow-x-auto h-[335px] overflow-y-auto ">
                              <DataTable columns={columns} data={data} />
                            </div>
                            <Pagination
                              goToPrevPage={previousPage}
                              goToNextPage={nextPage}
                              hasPrevPage={pagination.hasPrevPage}
                              hasNextPage={pagination.hasNextPage}
                              pagination={{
                                page: pagination.page,
                                totalPages: pagination.totalPages,
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
};

export default AllBanks;
